// extracted by mini-css-extract-plugin
export default {"red":"NoPermissionModal__red-KsmaE"};